<template>
    <div id="fonte" v-if="Object.values(fonte).length || {}">
        <el-collapse class="mx-2">
            <el-collapse-item>
                <p slot="title">
                    {{ $t('certification.messages.data_source') }}
                </p>

                <p class="mb-2">
                    {{ $t('certification.words.registration_date') }}:
                    {{ fonte.dataCadastro || '-' }}
                </p>
                <p class="mb-2">
                    {{ $t('certification.words.name') }}:
                    {{ fonte.nome || '-' }}
                </p>
                <a
                    v-if="fonte.url"
                    :href="fonte.url"
                    type="success"
                    target="_blank"
                >
                    {{ $t('certification.messages.official_source_website') }}
                </a>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    name: 'Fonte',

    data() {
        return {};
    },

    props: {
        fonte: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
#fonte {
    margin-left: 13px;

    .el-icon-arrow-right {
        margin-top: -13px;
        margin-left: 5px;
    }

    .el-collapse-item__wrap {
        border: none;
    }

    .el-collapse-item__header {
        border-bottom: none;
    }

    p {
        line-height: 1;
    }
}
</style>
